<template>
    <div class="bg-black m-0 h-screen overflow-x-hidden">
        <div class="mx-auto h-full flex flex-col justify-center items-center">
            <Fireworks />
            <div class="h-64 mx-4">
                <h3>
                    "Find the right color through my eyes,
                    <br />
                    Only the first to send the right answer will get rewarded."
                </h3>
            </div>
        </div>
        <Help />
    </div>
</template>

<script>
import Fireworks from '../components/Fireworks'
import Help from '../components/Help'

export default {
    comments: true,
    name: 'home',
    components: {
        Fireworks,
        Help
    },
    data() {
        return {
        }
    }
}
</script>
